import { createSlice } from '@reduxjs/toolkit';

/** Default form (serializable only; image/dexLogo/dexBanner are never stored) */
const getDefaultForm = () => ({
  name: '',
  symbol: '',
  decimals: 9,
  supply: '1000000000',
  description: '',
  website: '',
  telegram: '',
  discord: '',
  twitter: '',
  github: '',
  reddit: '',
  medium: '',
  instagram: '',
  youtube: '',
  linkedin: '',
  tags: [],
  tagInput: '',
  creatorName: 'IDX',
  creatorWebsite: 'https://www.idxsolana.io/',
  prefix: '',
  suffix: '',
  vanitySample: '4bH3A34WmSkefbPMj3JpqVAM8nS1qockyHjRTDo15Srm',
  distribution: [],
  distributionWallet: '',
  distributionShare: '',
  dexWebsite: '',
  dexTelegram: '',
  dexDiscord: '',
  dexTwitter: '',
});

const getDefaultToggles = () => ({
  creatorInfo: false,
  vanityAddress: false,
  vanityUsePrefix: false,
  vanityUseSuffix: false,
  multiWallet: false,
  dexTools: false,
  revokeFreeze: false,
  revokeMint: false,
  revokeUpdate: false,
});

const initialState = {
  form: getDefaultForm(),
  toggles: getDefaultToggles(),
};

const tokenCreatorFormSlice = createSlice({
  name: 'tokenCreatorForm',
  initialState,
  reducers: {
    setTokenCreatorForm: (state, action) => {
      const payload = action.payload;
      if (payload && typeof payload === 'object') {
        Object.keys(state.form).forEach((key) => {
          if (payload[key] !== undefined) state.form[key] = payload[key];
        });
      }
    },
    setTokenCreatorToggles: (state, action) => {
      const payload = action.payload;
      if (payload && typeof payload === 'object') {
        Object.keys(state.toggles).forEach((key) => {
          if (payload[key] !== undefined) state.toggles[key] = payload[key];
        });
      }
    },
    clearTokenCreatorForm: () => ({
      form: getDefaultForm(),
      toggles: getDefaultToggles(),
    }),
  },
});

export const {
  setTokenCreatorForm,
  setTokenCreatorToggles,
  clearTokenCreatorForm,
} = tokenCreatorFormSlice.actions;

export const selectTokenCreatorForm = (state) => state.tokenCreatorForm?.form ?? getDefaultForm();
export const selectTokenCreatorToggles = (state) => state.tokenCreatorForm?.toggles ?? getDefaultToggles();

export { getDefaultForm, getDefaultToggles };

export default tokenCreatorFormSlice.reducer;
